import { Component, OnInit } from '@angular/core';
import { trigger, transition, useAnimation } from '@angular/animations';
import { bounce, flipIn, bounceIn, zoomIn } from 'ng-animate';
@Component({
  selector: 'mm-part8',
  templateUrl: './part8.component.html',
  styleUrls: ['./part8.component.scss'],
  animations: [
    trigger('bounce', [transition(':enter', useAnimation(zoomIn))])
  ],
})
export class part8Component implements OnInit {
  bounce: any;
  readonly lstImages = [
    'jerusalem_municipality_logo.png'
    , 'hidabrut_logo.png'
    , 'netanya_logo.png'
    , 'ashdod_logo.png'
    , 'torat_emet_logo.png'
    , 'tashbar_logo.png'
    , 'ofakim_logo.png'
    , 'tsafon_logo.png'
    , 'yeshivot_logo.png'
    , 'tora_barama_logo.png'
    , 'discont_logo.jpg'
    , '3base_logo.jpg'
    , 'haifa_logo.jpeg'
    , 'mivchar_logo.png'
    , 'ben-gurion_logo.jpg'

    , 'meitarim_logo.jpg'
    , 'darkey-sara_logo.jpg'
    , 'ranana_logo.jpg'
    , 'moria_logo.jpg'
    , 'magen-avos_logo.jpg'
    , 'netsach-israel_logo.jpg'
    , 'netivot-moshe_logo.jpg'
    
  ]
  readonly baseURL = './assets/images/logo/'
  constructor() { }

  ngOnInit(): void {
  }

}
